<template>
  <span class="batch-status" :class="[statusClass(status), size === 'md' ? 'batch-status-md' : '']">
    <fa-icon :icon="['fal', getIcon(status)]"/>{{ getName(status) }}
  </span>
</template>

<script>
import { getName, getIcon, statusClass } from '@/data/billing-batch-statuses';

export default {
  props: {
    status: {
      type: String,
      required: true,
    },
    size: {
      type: String,
      default: 'sm',
    },
  },
  methods: {
    getName,
    getIcon,
    statusClass,
  },
};
</script>
